import React from 'react';
import PropTypes from 'prop-types';
import { Box, Title } from '@nerdwallet/currency';
import { stringInputSpec } from '../../lib/editing-configs';
import getTextColor from '../../lib/text-color-config';
import parseMarkdownLinks from '../../lib/parse-md-links';

import './link-button.less';

const LinkButton = ({ linkText, color }) => {
  if (!linkText) {
    return null;
  }

  const linkParser = (content) => parseMarkdownLinks(content, false);

  const { textColor } = getTextColor(color);
  const colorStyle = { color: textColor };

  return (
    <Box className="link-button">
      <Title bold style={colorStyle} size="small">
        {linkParser(linkText)}
      </Title>
    </Box>
  );
};

LinkButton.displayName = 'LinkButton';

LinkButton.propTypes = {
  linkUrl: PropTypes.string,
  linkText: PropTypes.string,
  color: PropTypes.string,
};

LinkButton.defaultProps = {
  linkText: '',
  color: '',
};

LinkButton.getEditingConfig = (componentDocument) => {
  return [
    stringInputSpec('linkText', 'Button extra text', {
      help: `Want a hyperlink? Write it like this: [Hi!](www.thing.com).
           NW links should be relative, e.g., [Home](/home)`,
    }),
    ...getTextColor.getEditingConfig(
      componentDocument,
      'linkColor',
      'Extra text color'
    ),
  ];
};

export default LinkButton;
